// extracted by mini-css-extract-plugin
export default {"AppointmentForm":"RefundForm_AppointmentForm__PO5qa"};